import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import API from "../api/api";

export default function SearchBox() {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (query.length < 2) {
            setResults([]);
            setOpen(false);
            return;
        }

        const delay = setTimeout(() => {
            API.get(`/search/?q=${query}`)
                .then(res => {
                    // ✅ VERY IMPORTANT FIX
                    if (Array.isArray(res.data)) {
                        setResults(res.data);
                        setOpen(true);
                    } else if (Array.isArray(res.data?.data)) {
                        // if backend returns { data: [] }
                        setResults(res.data.data);
                        setOpen(true);
                    } else {
                        setResults([]);
                        setOpen(false);
                    }
                })
                .catch(() => {
                    // ✅ prevent crash on API error
                    setResults([]);
                    setOpen(false);
                });
        }, 300);

        return () => clearTimeout(delay);
    }, [query]);

    return (
        <div className="relative w-full">
            {/* SEARCH INPUT */}
            <div className="flex items-center border border-gray-300 rounded-full px-4 py-2 bg-white dark:bg-gray-800">
                <FaSearch className="text-gray-400 text-sm mr-2" />
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search tech articles..."
                    className="w-full text-sm outline-none bg-transparent text-gray-900 dark:text-gray-100"
                />
            </div>

            {/* RESULTS DROPDOWN */}
            {open && Array.isArray(results) && results.length > 0 && (
                <div
                    className="
                        absolute
                        left-0
                        right-0
                        mt-2
                        bg-white
                        dark:bg-gray-900
                        border
                        border-gray-200
                        dark:border-gray-700
                        rounded-xl
                        shadow-lg
                        z-50
                    "
                >
                    {results.map((item) => (
                        <Link
                            key={item.id || item.slug}
                            to={`/article/${item.slug}`}
                            onClick={() => {
                                setOpen(false);
                                setQuery("");
                            }}
                            className="
                                block
                                px-4
                                py-3
                                text-sm
                                hover:bg-gray-100
                                dark:hover:bg-gray-800
                                text-gray-800
                                dark:text-gray-200
                            "
                        >
                            {item.title}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
